import { useMemo } from 'react';
import {
  Flex,
  RemoteImage,
  IconBookmark,
  IconBookmarkFilled,
  Colors,
  useScreenSize,
} from '@banhala/ui-kit';
import type { OutfitEntity } from './types';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';

// 컨테이너 paddingHorizontal(11.5) + 카드 paddingHorizontal(3.5) = 15px 스크린 엣지
const CONTAINER_PADDING = 11.5;
const CARD_PADDING = 3.5;
const SCREEN_PADDING = CONTAINER_PADDING + CARD_PADDING; // 15

type OutfitCardProps = {
  entity: OutfitEntity;
  isBookmarked: boolean;
  onToggleBookmark: (sno: number, nextBookmarked: boolean) => void;
};

export const OutfitCard = ({
  entity,
  isBookmarked,
  onToggleBookmark,
}: OutfitCardProps) => {
  const { item, logging } = entity;
  const { width: screenWidth } = useScreenSize();
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  // 카드 이미지 너비: (화면 너비 - 양쪽 스크린패딩 - 카드 간 갭) / 2
  const imageWidth = useMemo(
    () => (screenWidth - SCREEN_PADDING * 2 - CARD_PADDING * 2) / 2,
    [screenWidth],
  );
  const imageHeight = imageWidth * (4 / 3);

  const handlePressCard = () => {
    logAnalyticsEvent({
      name: 'CLICK_CONTENT',
      analytics: logging.analytics,
      ably_only_log: logging.ably_only_log,
    });
    openDeeplink(item.deeplink);
  };

  const handlePressBookmark = () => {
    const nextBookmarked = !isBookmarked;
    logAnalyticsEvent({
      name: 'CLICK_BOOKMARK',
      analytics: {
        ...logging.analytics,
        STATUS: nextBookmarked,
      },
      ably_only_log: logging.ably_only_log,
    });
    onToggleBookmark(item.sno, nextBookmarked);
  };

  return (
    <Flex
      width="50%"
      padding={{ horizontal: CARD_PADDING }}
      margin={{ bottom: 8 }}
    >
      <Flex onPress={handlePressCard}>
        <Flex borderRadius={4} overflow="hidden">
          <RemoteImage
            uri={item.thumbnail}
            width={imageWidth}
            height={imageHeight}
            resizeMode="cover"
            borderRadius="small"
          />
        </Flex>
        <Flex.Center
          onPress={handlePressBookmark}
          position="absolute"
          top={0}
          right={0}
          width={40}
          height={40}
          hitSlop={4}
        >
          {isBookmarked ? (
            <IconBookmarkFilled
              width={24}
              height={24}
              fill={Colors.content_always_white}
            />
          ) : (
            <IconBookmark
              width={24}
              height={24}
              fill={Colors.content_always_white}
            />
          )}
        </Flex.Center>
      </Flex>
    </Flex>
  );
};